import { ChevronDownIconComponent } from '@kuiper/icons';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'lib-accordion',
  imports: [ChevronDownIconComponent],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccordionComponent {
  accordionClass = input<string>();
  title = input<string>();
  titleClass = input<string>();
  detailsClass = input<string>();
  isOpen = input<boolean>(false);
  groupName = input<string | null>(null);
  disableToggle = input<boolean>(false);
  toggleAccordion = output();

  toggle() {
    this.toggleAccordion.emit();
  }
}
